exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".due[data-v-e3b1c908]{padding-left:35px!important;background-image:url(/assets/icons/bell--red.svg);background-repeat:no-repeat;background-position:10px}", ""]);

// exports
